var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.79406e-06 9.50003C-1.79812e-06 9.84055 0.13205 10.181 0.395599 10.4406L8.69309 18.6102C9.22091 19.1299 10.0767 19.1299 10.6043 18.6102C11.1319 18.0907 11.1319 17.2483 10.6043 16.7286L3.26222 9.50003L10.604 2.27143C11.1316 1.75174 11.1316 0.909399 10.604 0.389957C10.0764 -0.129986 9.22065 -0.129986 8.69283 0.389957L0.395343 8.55942C0.131751 8.81916 -1.79e-06 9.15964 -1.79406e-06 9.50003Z",
    fill: "url(#paint0_linear_0_395)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_395",
    x1: 11,
    y1: 18.6804,
    x2: 10.2781,
    y2: -0.389071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron_left.5ef87246a007986188671e7bd501ac69.svg";
export { ForwardRef as ReactComponent };